<template>
  <div id="home" class="page flex-r">
    <div class="home-left">
      <div class="logo">
        <img src="../../assets/img/logo2.png">
      </div>
      <div class="page-el">
        <el-menu router :default-active="activeIndex" background-color="#405891" text-color="rgba(255,255,255,0.6)"
          active-text-color="#fff" @select="handleSelect">
          <template v-for="(item, index) in menuList">
            <!-- 菜单只有一级 -->
            <el-menu-item :index="item.path" v-if="!item.children" :key="index">
              <i :class="`iconfont ${item.meta.icon}`"></i>
              <span slot="title" style="margin-left:10px">{{ item.meta.title }}</span>
            </el-menu-item>
            <!-- 多级菜单-->
            <el-submenu v-else :index="item.path" :key="index">
              <template slot="title">
                <i class="iconfont" :class="item.meta.icon"></i>
                <span style="margin-left:10px">{{ item.meta.title }}</span>
              </template>
              <el-menu-item v-for="child in item.children" :key="child.path" :index="child.path">
                <i :class="`iconfont ${child.meta.icon}`"></i>
                <span slot="title" style="margin-left:10px">{{ child.meta.title }}</span>
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </div>
    </div>
    <div class="home-right">
      <div class="header-nav flex-r">
        <div>
        </div>
        <a-popconfirm title="是否退出登录?" ok-text="是" cancel-text="否" @confirm="confirm" placement="rightBottom">
          <div style="cursor:pointer">
            <img src="../../assets/img/favicon.png">
            <span>{{ username }}</span>
          </div>
        </a-popconfirm>
      </div>
      <div class="child-page">
        <keep-alive v-if="$route.meta.fresh === 1">
          <router-view />
        </keep-alive>
        <router-view v-else />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: this.$route.path,
      searchContent: '',
      username: '',
      menuList: [],
    }
  },
  created() {
    this.initMenu()
    this.username = window.localStorage.getItem('account')
    var path = this.$route.path
    if (path.match('/index')) {
      this.$router.push('/timeData')
    }
  },
  methods: {
    confirm() {
      window.localStorage.clear()
      window.location.reload()
    },
    initMenu() {
      let menuData = this.$router.options.routes
      this.menuList = menuData[2].children.filter(item => item.meta.fresh === 1)
      if (window.localStorage.getItem('roleId') == '8') {
        this.menuList = this.menuList.filter(i => i.name == "timedata")
      }
    },
    // 切换路由
    handleSelect(val) {
      this.activeIndex = val
    },
  },
}
</script>

<style lang='less' scoped>
#home {
  background: #dee4f1;

  .home-left {
    min-width: 100px;
    background: #405891;
    width: 2.08rem;
    height: 100%;

    .logo {
      height: 0.38rem;
      margin: 0.14rem 0.24rem;
      width: 1.28rem;

      img {
        height: 100%;
      }
    }

    .page-el {
      font-size: 0.14rem;
      margin-top: 0.4rem;

      .iconfont {
        font-size: 18px;
      }
    }
  }

  .home-right {
    width: calc(100% - 2.08rem);
    // width: 17.12rem;
    min-width: 610px;
    height: 100%;

    .header-nav {
      background: #405891;
      height: 0.64rem;
      min-height: 30px;
      box-shadow: inset 0.04rem 0.04rem 0.04rem 0.02rem rgba(0, 0, 0, 0.05);
      padding: 0.16rem 0.32rem;
      justify-content: space-between;

      .header-search {
        width: 2.56rem;
        height: 0.32rem;
        min-height: 18px;
        min-width: 136px;
        border-radius: 0.16rem;
        background: #dee4f1;
        padding: 0 0.24rem;

        input {
          border: none;
          background: none;
          outline: none;
          color: black;
        }

        input::placeholder {
          color: #405891;
        }
      }

      img {
        width: 0.24rem;
        height: 0.24rem;
        border-radius: 0.12rem;
        margin-right: 0.08rem;
      }
    }
  }
}

.child-page {
  width: 100%;
  height: calc(100% - 0.64rem);
  background-color: #dee4f1;
}

::v-deep .el-menu {
  border-right: none
}

::v-deep .el-menu-item {
  height: 48px;
  line-height: 48px;
  font-size: 0.14rem;
}

.el-menu-item.is-active {
  background-color: #334674 !important;
}

::v-deep .el-menu-item i {
  color: rgba(255, 255, 255, 0.6);
}

::v-deep .el-submenu .el-menu-item {
  padding: unset;
  min-width: 100px;
  height: 48px;
  line-height: 48px;
  font-size: 0.14rem;
}

::v-deep .el-submenu__title {
  font-size: 0.14rem;
}

::v-deep .el-submenu__title i {
  color: rgba(255, 255, 255, 0.6);
}
</style>